import React, { useState } from "react";
import AdminNavbar from "./Compsoant/navbar/AdminNavbar";
import UsersSection from "./Compsoant/users/UsersSection";
import DashboardSection from "./Compsoant/dashboard/DashboardSection";
// Importez depuis le dossier qui contient l'index.js au lieu du fichier direct
import DevisSection from "./Compsoant/Devis/index"; // Au lieu de "./Compsoant/Devis/DevisSection"
import PaymentAdminPanel from "./Payment/PaymentAdminPanel";
import SizesManagement from "./Compsoant/Size/SizesManagement";
import ProductsManagement from "./Compsoant/products/ProductsManagement";
// import BlogManagement from "./Compsoant/Blog/BlogManagement";
// import New_Order from "./Compsoant/Order-test/New_Order";
import ContactMessages from "./Compsoant/ContactMessages/ContactMessages";
// import BlogManagement from "./Compsoant/Blog/BlogManagement";

const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminNavbar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        onMinimizeChange={setIsMinimized}
      />

      {/* Main Content */}
      <div className={`transition-all duration-300 ${isMinimized ? "lg:ml-20" : "lg:ml-80"} p-4 pt-20 lg:pt-4`}>

        {/* Content basé sur la section active */}
        {activeSection === "dashboard" && <DashboardSection />}
        {activeSection === "users" && <UsersSection />}
        {/* {activeSection === "products" && <ProductsSection />} */}
        {activeSection === "devis" && <DevisSection />}
        {activeSection === "Payement" && <PaymentAdminPanel />}
        {activeSection === "sizes" && <SizesManagement />}
        {activeSection === "Products" && <ProductsManagement />}
        {activeSection === "contact" && <ContactMessages />}
        {/* {activeSection === "Blog" && <BlogManagement />} */}
        {/* {activeSection === "Order_Test" && <New_Order />} */}
        {/* {activeSection === "Order_Test" && <New_Order />} */}

        {/* {activeSection === "orders" && <OrdersSection />} */}
      </div>
    </div>
  );
};

export default AdminDashboard;